module.exports = __webpack_public_path__ + "static/media/case-novair.d886f509.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case-novair.jpg
// module id = 84
// module chunks = 3